 export const HOME_PAGE_REQUEST = "HOME_PAGE_REQUEST"
export const HOME_PAGE_SUCCESS = "HOME_PAGE_SUCCESS"
export const HOME_PAGE_ERROR   = "HOME_PAGE_ERROR"

export const FIELD_POST_LIST_REQUEST = "FIELD_POST_LIST_REQUEST"
export const FIELD_POST_LIST_SUCCESS = "FIELD_POST_LIST_SUCCESS"
export const FIELD_POST_LIST_ERROR   = "FIELD_POST_LIST_ERROR"

export const SIGNUP_USER_REQUEST = "SIGNUP_USER_REQUEST"
export const SIGNUP_USER_SUCCESS = "SIGNUP_USER_SUCCESS"
export const SIGNUP_USER_ERROR   = "SIGNUP_USER_ERROR"

export const SIGNIN_USER_REQUEST = "SIGNIN_USER_REQUEST"
export const SIGNIN_USER_SUCCESS = "SIGNIN_USER_SUCCESS"
export const SIGNIN_USER_ERROR   = "SIGNIN_USER_ERROR"

export const  RESUME_FILE_POST_REQUEST = "RESUME_FILE_POST_REQUEST"  
export const  RESUME_FILE_POST_SUCCESS = "RESUME_FILE_POST_SUCCESS"
export const  RESUME_FILE_POST_ERROR   = "RESUME_FILE_POST_ERROR"

export const  UPDATE_PROFILE_REQUEST = "UPDATE_PROFILE_REQUEST"  
export const  UPDATE_PROFILE_SUCCESS = "UPDATE_PROFILE_SUCCESS"
export const  UPDATE_PROFILE_ERROR   = "UPDATE_PROFILE_ERROR"

export const  RESUME_POST_TO_REQUEST = "RESUME_POST_TO_REQUEST"  
export const  RESUME_POST_TO_SUCCESS = "RESUME_POST_TO_SUCCESS"
export const  RESUME_POST_TO_ERROR   = "RESUME_POST_TO_ERROR"


export const ADMIN_CATEGORY_ADD_REQUEST="ADMIN_CATEGORY_ADD_REQUEST"
export const ADMIN_CATEGORY_ADD_SUCCESS="ADMIN_CATEGORY_ADD_SUCCESS"
export const ADMIN_CATEGORY_ADD_ERROR="ADMIN_CATEGORY_ADD_ERROR"

export const ADMIN_CATEGORY_UPDATE_REQUEST="ADMIN_CATEGORY_UPDATE_REQUEST"
export const ADMIN_CATEGORY_UPDATE_SUCCESS="ADMIN_CATEGORY_UPDATE_SUCCESS"
export const ADMIN_CATEGORY_UPDATE_ERROR="ADMIN_CATEGORY_UPDATE_ERROR"

export const ADMIN_CATEGORY_LIST_REQUEST="ADMIN_CATEGORY_LIST_REQUEST"
export const ADMIN_CATEGORY_LIST_SUCCESS="ADMIN_CATEGORY_LIST_SUCCESS"
export const ADMIN_CATEGORY_LIST_ERROR="ADMIN_CATEGORY_LIST_ERROR"

export const ADMIN_CATEGORY_DELETE_REQUEST="ADMIN_CATEGORY_DELETE_REQUEST"
export const ADMIN_CATEGORY_DELETE_SUCCESS ="ADMIN_CATEGORY_DELETE_SUCCESS"
export const ADMIN_CATEGORY_DELETE_ERROR ="ADMIN_CATEGORY_DELETE_ERROR"

export const  CONTACT_US_LIST_REQUEST = "CONTACT_US_LIST_REQUEST"  
export const  CONTACT_US_LIST_SUCCESS = "CONTACT_US_LIST_SUCCESS"
export const  CONTACT_US_LIST_ERROR   = "CONTACT_US_LIST_ERROR" 

export const  CONTACT_US_REPLAYE_REQUEST = "CONTACT_US_REPLAYE_REQUEST"  
export const  CONTACT_US_REPLAYE_SUCCESS = "CONTACT_US_REPLAYE_SUCCESS"
export const  CONTACT_US_REPLAYE_ERROR   = "CONTACT_US_REPLAYE_ERROR" 

export const  USERS_LIST_REQUEST ="USERS_LIST_REQUEST"
export const  USERS_LIST_SUCCESS ="USERS_LIST_SUCCESS"
export const  USERS_LIST_ERROR   ="USERS_LIST_ERROR"

export const  USERS_STATUS_CHANGE_REQUEST ="USERS_STATUS_CHANGE_REQUEST"
export const  USERS_STATUS_CHANGE_SUCCESS ="USERS_STATUS_CHANGE_SUCCESS"
export const  USERS_STATUS_CHANGE_ERROR   ="USERS_STATUS_CHANGE_ERROR"

export const  ALL_COUNT_GET_REQUEST ="ALL_COUNT_GET_REQUEST"
export const  ALL_COUNT_GET_SUCCESS ="ALL_COUNT_GET_SUCCESS"
export const  ALL_COUNT_GET_ERROR   ="ALL_COUNT_GET_ERROR"

export const  ADD_STATECITYCOUNTRY_REQUEST = "ADD_STATECITYCOUNTRY_REQUEST"
export const  ADD_STATECITYCOUNTRY_SUCCESS = "ADD_STATECITYCOUNTRY_SUCCESS"
export const  ADD_STATECITYCOUNTRY_ERROR = "ADD_STATECITYCOUNTRY_ERROR"

export const  LIST_STATECITYCOUNTRY_REQUEST = "LIST_STATECITYCOUNTRY_REQUEST"
export const  LIST_STATECITYCOUNTRY_SUCCESS = "LIST_STATECITYCOUNTRY_SUCCESS"
export const  LIST_STATECITYCOUNTRY_ERROR = "LIST_STATECITYCOUNTRY_ERROR"

export const  CITY_STATUS_CHANGE_REQUEST = "CITY_STATUS_CHANGE_REQUEST"
export const  CITY_STATUS_CHANGE_SUCCESS = "CITY_STATUS_CHANGE_SUCCESS"
export const  CITY_STATUS_CHANGE_ERROR = "CITY_STATUS_CHANGE_ERROR"

export const  ADMIN_CATEGORY_STATUS_CHANGE_REQUEST = "ADMIN_CATEGORY_STATUS_CHANGE_REQUEST"
export const  ADMIN_CATEGORY_STATUS_CHANGE_SUCCESS = "ADMIN_CATEGORY_STATUS_CHANGE_SUCCESS"
export const  ADMIN_CATEGORY_STATUS_CHANGE_ERROR = "ADMIN_CATEGORY_STATUS_CHANGE_ERROR"

export const  ADMIN_CATEGORY_ORDER_CHANGE_REQUEST = "ADMIN_CATEGORY_ORDER_CHANGE_REQUEST"
export const  ADMIN_CATEGORY_ORDER_CHANGE_SUCCESS = "ADMIN_CATEGORY_ORDER_CHANGE_SUCCESS"
export const  ADMIN_CATEGORY_ORDER_CHANGE_ERROR = "ADMIN_CATEGORY_ORDER_CHANGE_ERROR"

export const ADMIN_BLOG_ADD_REQUEST="ADMIN_BLOG_ADD_REQUEST"
export const ADMIN_BLOG_ADD_SUCCESS="ADMIN_BLOG_ADD_SUCCESS"
export const ADMIN_BLOG_ADD_ERROR="ADMIN_BLOG_ADD_ERROR"

export const ADMIN_BLOG_UPDATE_REQUEST = "ADMIN_BLOG_UPDATE_REQUEST"
export const ADMIN_BLOG_UPDATE_SUCCESS = "ADMIN_BLOG_UPDATE_SUCCESS"
export const ADMIN_BLOG_UPDATE_ERROR = "ADMIN_BLOG_UPDATE_ERROR"

export const ADMIN_BLOG_LIST_REQUEST="ADMIN_BLOG_LIST_REQUEST"
export const ADMIN_BLOG_LIST_SUCCESS="ADMIN_BLOG_LIST_SUCCESS"
export const ADMIN_BLOG_LIST_ERROR="ADMIN_BLOG_LIST_ERROR"

export const ADMIN_BLOG_DELETE_REQUEST="ADMIN_BLOG_DELETE_REQUEST"
export const ADMIN_BLOG_DELETE_SUCCESS ="ADMIN_BLOG_DELETE_SUCCESS"
export const ADMIN_BLOG_DELETE_ERROR ="ADMIN_BLOG_DELETE_ERROR"

export const  ADMIN_BLOG_STATUS_CHANGE_REQUEST = "ADMIN_BLOG_STATUS_CHANGE_REQUEST"
export const  ADMIN_BLOG_STATUS_CHANGE_SUCCESS = "ADMIN_BLOG_STATUS_CHANGE_SUCCESS"
export const  ADMIN_BLOG_STATUS_CHANGE_ERROR = "ADMIN_BLOG_STATUS_CHANGE_ERROR"

export const  ADMIN_BLOG_ORDER_CHANGE_REQUEST = "ADMIN_BLOG_ORDER_CHANGE_REQUEST"
export const  ADMIN_BLOG_ORDER_CHANGE_SUCCESS = "ADMIN_BLOG_ORDER_CHANGE_SUCCESS"
export const  ADMIN_BLOG_ORDER_CHANGE_ERROR = "ADMIN_BLOG_ORDER_CHANGE_ERROR"

export const  RESUME_ACTIVITY_LIST_REQUEST = "RESUME_ACTIVITY_LIST_REQUEST"
export const  RESUME_ACTIVITY_LIST_SUCCESS = "RESUME_ACTIVITY_LIST_SUCCESS"
export const  RESUME_ACTIVITY_LIST_ERROR = "RESUME_ACTIVITY_LIST_ERROR"




// WEBPACK FOOTER //
// ./src/actions/Admin/actionTypes.js